import { DEFAULT_SECURITY_GROUP_NAMES } from 'cloud-networks/modules/SecurityGroupModule/SecurityGroupConstants';

const isDefaultGroup = (group) => {
    return group.name === 'default';
};

const isDefaultGroupName = (name) => {
    return DEFAULT_SECURITY_GROUP_NAMES.includes(name);
};

export const SecurityGroupUtils = {
    isDefaultGroup,
    isDefaultGroupName,
};
